



















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class PageTitle extends Vue {
  private pageName: string = ''

  @Prop() private title!: string

  created () {
    if (this.title !== '' && this.title !== undefined) {
      this.pageName = this.title
    } else {
      this.pageName = String(this.$route.name)
    }
  }
}
